export default {
  fontWeightActive: '400'
};